module.exports = __webpack_public_path__ + "static/img/10003 (5).871e9a6.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10003 (5).webp
// module id = w4yK
// module chunks = 14